<template>
  <transition name="drawer" v-if="is.drawerOpen">
    <section class="unum-drawer">
      <span @click="closeDrawerEvent" class="menu-close">Close Menu</span>

      <ul class="menu-list">
        <li>
          <router-link
            :to="{ name: 'Lookup' }"
            class="button button--outline button--fullWidth button--blue"
            active-class="button--hover"
            @click.native="newPath('lookup')"
          >Platform Lookup</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'Compare' }"
            class="button button--outline button--fullWidth button--blue"
            active-class="button--hover"
            @click.native="newPath('compare')"
          >Compare Platforms</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'Wizard' }"
            class="button button--outline button--fullWidth button--blue"
            active-class="button--hover"
            @click.native="newPath('wizard')"
          >Help Me Choose A Platform</router-link>
        </li>
        <li>
          <unum-button
            small outline
            color="blue"
            @click.native="fullyLogout"
          >
            Logout
          </unum-button>
        </li>
        <!-- <li>
          <unum-button
            small outline
            color="blue"
            @click.native="fullyClearSession"
          >
            Clear Session
          </unum-button>
        </li> -->
      </ul>
    </section>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import UnumButton from '@/components/ui/Button'

import sessionEvent from '@/util/sessionEvent'

export default {
  name: 'UnumDrawer',
  components: {
    UnumButton
  },
  methods: {
    ...mapActions('shared', [
      'toggleDrawer'
    ]),
    ...mapActions('user', [
      'logout',
      'clearSession'
    ]),
    ...mapActions('platforms', [
      'clearCurrentPlatform',
      'clearChosenPlatforms'
    ]),
    ...mapActions('wizard', [
      'clearWizard'
    ]),
    closeDrawerEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_drawer_close')
      this.toggleDrawer()
    },
    fullyLogout () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_drawer_logout')
      this.clearWizard()
      this.clearCurrentPlatform()
      this.clearChosenPlatforms()
      this.logout()
    },
    fullyClearSession () {
      this.clearWizard()
      this.clearCurrentPlatform()
      this.clearChosenPlatforms()
      this.clearSession()
    },
    newPath (toRoute) {
      const sessionKey = this.$storage.get('session_key')
      if (toRoute.toLowerCase() === 'wizard') {
        sessionEvent(sessionKey, 'clicked_drawer_wizard_button')
      }
      if (toRoute.toLowerCase() === 'compare') {
        sessionEvent(sessionKey, 'clicked_drawer_compare_button')
      }
      if (toRoute.toLowerCase() === 'lookup') {
        sessionEvent(sessionKey, 'clicked_drawer_lookup_button')
      }
      if (
        // this.isWizardDataAvailable &&
        this.$route.name !== 'Wizard' &&
        this.$route.name !== 'WizardSummary' &&
        this.$route.name !== 'Compare'
      ) {
        this.clearWizard()
        this.clearCurrentPlatform()
        this.clearChosenPlatforms()
      }
    }
  },
  computed: {
    ...mapState('shared', [
      'is'
    ]),
    ...mapGetters('wizard', [
      'isWizardDataAvailable'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.unum-drawer {
  background: #fff;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  transition: transform .5s cubic-bezier(0.77,0.2,0.05,1.0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: -2px 0px 10px 0 rgba(0,0,0,0.25);
  z-index: 10;
  width: 100%;
  padding: 3rem 4rem;

  @include bp($medium) {
    width: 50%;
    padding: 1rem;
  }
}

.menu-close {
  position: absolute;
  top: 3.5rem;
  right: 3rem;
  text-indent: -9999px;
  background: url('~@/assets/images/ui/x-blue.svg') center center no-repeat;
  background-size: contain;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}

.menu-list {
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0 2rem;

  li + li {
    margin: 2rem auto 0;
  }
}

// animation
.drawer {
  &-enter-active,
  &-fade-leave-active {
    transform: translate3d(0, 0, 0);
  }

  &-enter,
  &-leave-to {
    transform: translate3d(100%, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Drawer.vue